import { useContentfulLiveUpdates } from "@contentful/live-preview/react"
import FlexibleData from "@lib/flexibleData"
import FilterGridTemplate from "@templates/filter-grid"
import { getIntegrationData } from "@lib/api"
import { fetchRecommended } from "@lib/fetchRecommended"

import Button from "@components/button"

import { no_results_container } from "./styles.module.scss"

export async function getStaticProps(context) {
  const preview = process.env.NODE_ENV === "development" || context.draftMode || false
  const previewEnv = context?.previewData?.environment || null
  const pageData = (await FlexibleData.fetch("integrations", preview, previewEnv)) ?? []

  const integrationsData = (await getIntegrationData(preview)) ?? []

  const categoriesSet = new Set()
  const typesSet = new Set()

  integrationsData.forEach((item) => {
    item.types.forEach((type) => {
      if (type) typesSet.add(type)
    })
    item.categories.forEach((cat) => {
      if (cat) categoriesSet.add(cat)
    })
  })

  const dropdownOptions = {
    types: [...typesSet].sort((a, b) => a.localeCompare(b)),
    categories: [...categoriesSet].sort((a, b) => a.localeCompare(b))
  }

  const recommended = pageData.showRecommended
    ? await fetchRecommended(
        pageData?.recommendedCollection?.items,
        "integrations",
        undefined,
        preview
      )
    : null

  return {
    props: {
      preview,
      pageData,
      integrationsData,
      dropdownOptions,
      recommended
    }
  }
}

const IntegrationsIndex = ({
  preview,
  pageData,
  integrationsData,
  dropdownOptions,
  recommended
}) => {
  const livePageData = useContentfulLiveUpdates(pageData)

  const noResultsMessage = (
    <div className={no_results_container}>
      <p>
        It looks like we have not built a direct integration to this product — yet! <br />
        Let us know which one you were looking for and we'll be in touch.
      </p>
      <Button url="/contact">Contact Us</Button>
    </div>
  )

  return (
    <FilterGridTemplate
      pageData={livePageData}
      contentData={integrationsData}
      dropdownOptions={dropdownOptions}
      recommendedProps={{
        recommended: recommended
      }}
      preview={preview}
      cardType="integration"
      route={livePageData.slug}
      canonical="https://amperity.com/integrations"
      customNoResultsMessage={noResultsMessage}
      hasTextSearch
    />
  )
}

export default IntegrationsIndex
